import { rollupResolver } from "resolvers";

const rollupsResolver = ({ table }) => {
  return table.map(rollupResolver);
};

export default rollupsResolver;
